import type { Event } from "@sentry/vue";

const inspectionFunctions = new Set([
  "findTopmostVisibleElement",
  "checkForImage",
  "isImage",
]);

/** Signature du script d'inspection injecté dans les pages par Google sur iOS.
 * Son URL est celle du document, ce qui le fait apparaître comme du code applicatif.
 * Conserver toute pile contenant d'autres fonctions ou des fichiers de l'app. */
export function isGoogleIosInspectionError(event: Event): boolean {
  const headers = event.request?.headers;
  const userAgent = headers?.["User-Agent"] ?? headers?.["user-agent"] ?? "";
  if (!/\bGSA\//.test(userAgent) || !/\b(iPhone|iPad|iPod)\b/.test(userAgent)) {
    return false;
  }

  const exceptions = event.exception?.values ?? [];
  const exception = exceptions[0];
  if (
    exceptions.length !== 1 ||
    exception?.type !== "RangeError" ||
    !/^Maximum call stack size exceeded\.?$/.test(exception.value ?? "")
  ) {
    return false;
  }

  const pageUrl = event.request?.url;
  const frames = exception.stacktrace?.frames ?? [];
  return Boolean(
    pageUrl &&
    frames.filter((frame) => frame.function === "findTopmostVisibleElement")
      .length >= 2 &&
    frames.some((frame) => frame.function === "checkForImage") &&
    frames.some((frame) => frame.function === "isImage") &&
    frames.every(
      (frame) =>
        frame.filename === pageUrl &&
        inspectionFunctions.has(frame.function ?? ""),
    ),
  );
}
